import { CalendarLineIcon, Empty } from 'ui';
import { EventListItem, EventsListGroup, EventsListGroupSkeleton } from 'features/events';
import { type EventWithSource, useGetEvents } from '../../hooks';
import type { EventsType } from '../DeclinedEventsModal';
import { useCreateEventExtra, useCreateEventListItem, useCreateEventListItems } from './hooks';

export type EventItem = {
  id: string;
  startTime: Date;
} & EventWithSource;

type P = {
  getPathToEventDetail: (id: string) => string;
  type: EventsType;
};

const DeclinedEvents = ({ getPathToEventDetail, type }: P) => {
  const createEventListItems = useCreateEventListItems();
  const createEventListItem = useCreateEventListItem();
  const createEventExtra = useCreateEventExtra();
  const { events, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isRefetching } = useGetEvents({
    rsvp: ['not_going' as const],
    type,
  });

  if (isLoading || !events) {
    return <EventsListGroupSkeleton />;
  }

  if (events.length === 0) {
    return (
      <Empty
        description={{ subtitle: 'If you decline an event, it will appear here', title: 'No declined events' }}
        image={<CalendarLineIcon />}
      />
    );
  }

  const eventListItems = createEventListItems({ events });

  return (
    <EventsListGroup<EventItem>
      createItem={(item) => (
        <EventListItem
          event={createEventListItem({ item })}
          extra={createEventExtra({ item })}
          getPathToEventDetail={getPathToEventDetail}
        />
      )}
      events={eventListItems}
      getPathToEventDetail={getPathToEventDetail}
      query={{
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isRefetching,
      }}
    />
  );
};

export default DeclinedEvents;
